import { api } from "../../lib/api";
import type { PlatformStats } from "../../types/admin";

// Dashboard API Service
export const dashboardService = {
	// Get dashboard statistics
	getStats: async (): Promise<PlatformStats> => {
		const response = await api.get<PlatformStats>("/admin/stats");
		if (!response.data.success || !response.data.data) {
			throw new Error("Failed to fetch dashboard stats");
		}
		return response.data.data as PlatformStats;
	},
};
